import React from 'react';
import {
  Inbox,
  CalendarCheck,
  Users,
  BarChart3,
  MessagesSquare,
} from 'lucide-react';
import FeatureSection from './FeatureSection';

const features = [
  {
    title: 'Unified Inbox',
    desc: 'Manage every conversation in one place with advanced filtering by priority, channel, status and assignee.',
    icon: <Inbox size={20} />,
    bg: '#e0f7fe',
    color: '#06b6ec',
  },
  {
    title: 'Appointment Management',
    desc: 'A dedicated module for Pending, Confirmed and Cancelled bookings made directly by the AI agent.',
    icon: <CalendarCheck size={20} />,
    bg: '#dcfce7',
    color: '#22c55e',
  },
  {
    title: 'Team Permissions',
    desc: 'Create multiple agent accounts with granular access levels — let staff manage just customers or just bookings.',
    icon: <Users size={20} />,
    bg: '#ede9fe',
    color: '#8b5cf6',
  },
  {
    title: 'Analytics Dashboard',
    desc: 'Track total messages, active customers, response times and conversion metrics in real time.',
    icon: <BarChart3 size={20} />,
    bg: '#fef3c7',
    color: '#d97706',
  },
  {
    title: 'Channel-Specific Prompts',
    desc: 'Give the AI a unique persona, tone or knowledge base per channel — WhatsApp casual, Email formal, etc.',
    icon: <MessagesSquare size={20} />,
    bg: '#fee2e2',
    color: '#ef4444',
  },
];

export default function Operations() {
  return (
    <FeatureSection
      id="operations"
      eyebrow="Operations · Team Management"
      title="Built for teams that actually run support"
      description="Everything your operators need on day one — inbox, bookings, permissions and analytics — without the cost of stitching five tools together."
      features={features}
      variant="alt"
    />
  );
}
